import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const FormikDatePicker = ({
  formik,
  fieldName,
  onChange,
  startDate,
  maxDate,
  minDate,
}) => (
  <>
    <DatePicker
      className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel dateStyle cp ${
        formik.touched[fieldName] && formik.errors[fieldName] && "is-invalid"
      }`}
      selected={startDate}
      onChange={(date) => onChange(date)}
      name="eventDate"
      dateFormat="MM/dd/yyyy"
      minDate={minDate}
      maxDate={maxDate}
    />
    <div className="errorMsg fs-14 medium">
      {formik.touched[fieldName] && formik.errors[fieldName]}
    </div>
  </>
);

export default FormikDatePicker;
